<!-- ===================== INTRO: cortina mientras carga el 3D ===================== -->
<div class="in" *ngIf="intro" [class.in--fuera]="revelado" (click)="revelar()" aria-hidden="true">
	<div class="in-centro">
		<img class="in-logo" src="assets/images/sorteo2026/logo-magno.png" alt="Sorteo Anáhuac" width="255" height="57">
		<span class="in-barra"><i [class.lleno]="cargado"></i></span>
	</div>
</div>

<!-- ===================== HERO ===================== -->
<section class="hp" [class.hp--revelado]="revelado">
	<div class="hp-int">
		<div class="hp-cab">
			<h1 class="hp-titulo">
				<span class="ln"><span>La casa que puedes ganar.</span></span>
			</h1>
			<div class="hp-lado">
				<p>Recórrela en 3D, tal como es.</p>
				<div class="hp-acciones">
					<a class="btn btn--primario" [href]="urlCompra" target="_blank" rel="noopener">Compra tu boleto</a>
					<button type="button" class="btn btn--linea" (click)="entrar()">Entrar a la casa</button>
				</div>
			</div>
		</div>

		<!-- el marco conserva el hueco; .hp-casa es el que se expande a pantalla completa -->
		<div class="hp-marco" #marco>
			<div class="hp-casa" #casa [class.hp-casa--lista]="cargado" [class.hp-casa--inmersivo]="inmersivo"
				[style.background-image]="'url(' + portada + ')'">
				<iframe [src]="urlVisor" (load)="alCargar()" title="Recorrido 3D de la casa"
					allow="autoplay; fullscreen; web-share; xr-spatial-tracking" allowfullscreen></iframe>
			</div>

			<button type="button" class="hp-entrar" (click)="entrar()" *ngIf="!inmersivo">
				<span class="hp-entrar__txt">
					<small>Recorrido 3D</small>
					Entrar a la casa
				</span>
				<span class="hp-entrar__flecha" aria-hidden="true">→</span>
			</button>
		</div>
	</div>
</section>

<!-- ===================== CÓMO SE RECORRE ===================== -->
<section class="hc">
	<div class="hp-int">
		<div class="hc-cab">
			<h2>Cómo recorrerla</h2>
			<p>Funciona en computadora y en celular. No necesitas instalar nada.</p>
		</div>
		<ol class="hc-lista">
			<li *ngFor="let p of pasos; let i = index">
				<span class="hc-num">{{ i + 1 }}</span>
				<h3>{{ p.titulo }}</h3>
				<p>{{ p.texto }}</p>
			</li>
		</ol>
	</div>
</section>

<!-- ===================== CIERRE ===================== -->
<section class="hf">
	<div class="hp-int hf-int">
		<h2>Un boleto.<br>Las llaves.</h2>
		<div class="hp-acciones">
			<a class="btn btn--primario" [href]="urlCompra" target="_blank" rel="noopener">Compra tu boleto</a>
			<button type="button" class="btn btn--claro" (click)="entrar()">Volver a recorrerla</button>
		</div>
	</div>
</section>

<!-- ===================== CAPA DEL RECORRIDO (encima del visor expandido) ===================== -->
<div class="ht" *ngIf="inmersivo" role="dialog" aria-modal="true" aria-label="Recorrido 3D">
	<header class="ht-barra">
		<button type="button" class="ht-pill" (click)="salir()"><span aria-hidden="true">←</span> Salir</button>
		<div class="ht-barra__der">
			<button type="button" class="ht-pill ht-ayuda" *ngIf="!guiaVisible" (click)="abrirGuia()">¿Cómo me muevo?</button>
			<a class="ht-pill ht-pill--primario" [href]="urlCompra" target="_blank" rel="noopener">Compra tu boleto</a>
		</div>
	</header>

	<aside class="ht-guia" *ngIf="guiaVisible">
		<ng-container *ngIf="!terminoGuia; else fin">
			<div class="ht-guia__cab">
				<span>{{ paso + 1 }} / {{ pasos.length }}</span>
				<button type="button" (click)="guiaVisible = false" aria-label="Cerrar guía">✕</button>
			</div>
			<h3>{{ pasos[paso].titulo }}</h3>
			<p>{{ pasos[paso].texto }}</p>
			<div class="ht-guia__pie">
				<div class="ht-puntos">
					<button type="button" *ngFor="let p of pasos; let i = index" [class.on]="i <= paso"
						(click)="paso = i" [attr.aria-label]="'Paso ' + (i + 1)"></button>
				</div>
				<button type="button" class="btn btn--chico btn--oscuro" (click)="paso = paso + 1">
					{{ paso === pasos.length - 1 ? 'Listo' : 'Siguiente' }}
				</button>
			</div>
		</ng-container>

		<ng-template #fin>
			<h3>Listo, ya sabes moverte.</h3>
			<p>Recórrela a tu ritmo. Cuando te convenza, un boleto te puede dar las llaves.</p>
			<div class="ht-guia__pie ht-guia__pie--fin">
				<button type="button" class="btn btn--chico btn--linea-oscura" (click)="guiaVisible = false">Seguir explorando</button>
				<a class="btn btn--chico btn--primario" [href]="urlCompra" target="_blank" rel="noopener">Compra tu boleto</a>
			</div>
		</ng-template>
	</aside>
</div>
